import React from 'react';
import { TableOptions } from 'types/Table';
import Comments from './Comments';

// meta inforoation
import commentsMeta from '../../../../../resources/comments.json';

interface ICreatTabProps {
  conditions?: any;
  createTab: (path: string, title: string) => void;
  tableOptions?: TableOptions;
}

const WrappedComments = ({ createTab, conditions, tableOptions }: ICreatTabProps) => {
  return <Comments
    conditions={conditions}
    createTab={createTab}
    commentsMeta={commentsMeta}
    tableOptions={tableOptions}
  />
};

export default React.memo(WrappedComments);
